// The History tab: the saves of a version, what each one changed, and reverting to before one
const en = {
  title: 'History',
  description: (version: string) =>
    `Every save of version ${version}, latest first. See what each one changed, or revert to before it.`,
  loadFailed: 'Failed to load revision history',
  detailsFailed: 'Failed to load revision details',
  revertFailed: 'Failed to revert to revision',
  empty: 'No revision history available.',
  seeChanges: 'See changes',
  changesSaved: 'Changes saved',
  savedBy: (email: string, date: string) => `By ${email}, ${date}`,
  cannotRebuild: 'This change can\'t be rebuilt from the history, so it can\'t be reverted. Raw patch, from after to before the save:',
  nothingChanged: 'This save didn\'t change anything.',
  kinds: {
    added: 'Added',
    removed: 'Removed',
    changed: 'Changed',
    reordered: 'Reordered',
  },
  before: 'Before',
  after: 'After',
  /** A value the data didn't have, before or after the save */
  nothing: 'nothing',
  revertToBefore: 'Revert to before this change',
  confirmTitle: 'Confirm revert',
  willBeSaved: (version: string) => `Version ${version} will be saved as it was before this change`,
  alsoUndoes: (count: number) => `, which also undoes the ${count} later ${count === 1 ? 'change' : 'changes'} listed above it`,
  publishedWarning: 'This version is published: the apps will show the reverted content right away.',
  staysDraft: 'This version stays a draft.',
  canUndo: 'The revert is added to the history, so you can undo it.',
  reverting: 'Reverting…',
  revert: 'Revert',
};

const fr: typeof en = {
  title: 'Historique',
  description: (version: string) =>
    `Chaque enregistrement de la version ${version}, du plus récent au plus ancien. Voyez ce que chacun a modifié, ou rétablissez l'état d'avant.`,
  loadFailed: 'Impossible de charger l\'historique',
  detailsFailed: 'Impossible de charger le détail de la modification',
  revertFailed: 'Impossible de rétablir l\'état d\'avant cette modification',
  empty: 'Aucun historique disponible.',
  seeChanges: 'Voir les modifications',
  changesSaved: 'Modifications enregistrées',
  savedBy: (email: string, date: string) => `Par ${email}, ${date}`,
  cannotRebuild: 'Cette modification ne peut pas être reconstituée à partir de l\'historique, l\'état d\'avant ne peut donc pas être rétabli. Patch brut, de l\'après vers l\'avant de l\'enregistrement\u00a0:',
  nothingChanged: 'Cet enregistrement n\'a rien modifié.',
  kinds: {
    added: 'Ajouté',
    removed: 'Supprimé',
    changed: 'Modifié',
    reordered: 'Réordonné',
  },
  before: 'Avant',
  after: 'Après',
  nothing: 'rien',
  revertToBefore: 'Rétablir l\'état d\'avant cette modification',
  confirmTitle: 'Confirmer le rétablissement',
  willBeSaved: (version: string) => `La version ${version} sera enregistrée telle qu'elle était avant cette modification`,
  alsoUndoes: (count: number) => count > 1
    ? `, ce qui annule aussi les ${count} modifications plus récentes listées au-dessus`
    : ', ce qui annule aussi la modification plus récente listée au-dessus',
  publishedWarning: 'Cette version est publiée\u00a0: les apps afficheront tout de suite le contenu rétabli.',
  staysDraft: 'Cette version reste un brouillon.',
  canUndo: 'Le rétablissement est ajouté à l\'historique, vous pourrez donc l\'annuler.',
  reverting: 'Rétablissement…',
  revert: 'Rétablir',
};

const messages = { en, fr };
export default messages;
